// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.columns_actionsColumnWrapper__EP9cu {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.columns_actionsColumn__szblM {
  padding: 1px;
  border: 1px solid var(--mui-palette-grey-400);
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  min-height: 22px;
  box-sizing: border-box;
}

.columns_actionsColumnIcon__UerMb {
  stroke: var(--mui-palette-grey-400);
  stroke-width: 0;
  fill: var(--mui-palette-grey-400);
}

.columns_sortColumnIcon__smo2Y {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/table/columns/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".actionsColumnWrapper {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n\n.actionsColumn {\n  padding: 1px;\n  border: 1px solid var(--mui-palette-grey-400);\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  min-height: 22px;\n  box-sizing: border-box;\n}\n\n.actionsColumnIcon {\n  stroke: var(--mui-palette-grey-400);\n  stroke-width: 0;\n  fill: var(--mui-palette-grey-400);\n}\n\n.sortColumnIcon {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionsColumnWrapper": `columns_actionsColumnWrapper__EP9cu`,
	"actionsColumn": `columns_actionsColumn__szblM`,
	"actionsColumnIcon": `columns_actionsColumnIcon__UerMb`,
	"sortColumnIcon": `columns_sortColumnIcon__smo2Y`
};
export default ___CSS_LOADER_EXPORT___;
